export const getFilenameFromContentDisposition = (contentDisposition: string): string | "download" => {
  const match = contentDisposition.match(/filename=([^;]*)/);
  return match && match[1] ? match[1] : "download.csv";
};
